(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-with-text-video"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('image-text-video')) {
  customElements.define('image-text-video', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      this.fallback = this.querySelector('.image-text-video__fallback');
      if (!this.video || !this.button) return;

      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };
      this.autoplayEnabled = this.dataset.autoplay === 'true';
      this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.inView = false;
      this.userPaused = false;
      this.manualPlayback = false;
      this.video.controls = false;
      this.button.hidden = false;

      const reflectPlayback = () => {
        this.toggleAttribute('data-playing', !this.video.paused);
        this.button.setAttribute('aria-label', this.video.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
      };

      const play = () => {
        if (this.failed) return;
        this.video.play().catch(reflectPlayback);
      };

      const syncPlayback = () => {
        if (this.failed) return;
        const canAutoplay = this.autoplayEnabled && !this.motionPreference.matches && !this.userPaused;
        if (this.inView && !document.hidden && (this.manualPlayback || canAutoplay)) {
          play();
        } else {
          this.video.pause();
        }
      };

      this.video.addEventListener('play', reflectPlayback, options);
      this.video.addEventListener('pause', reflectPlayback, options);
      this.video.addEventListener('ended', reflectPlayback, options);
      this.video.addEventListener('error', () => {
        this.failed = true;
        this.button.hidden = true;
        this.video.hidden = true;
        if (this.fallback) this.fallback.hidden = false;
        this.manualPlayback = false;
        this.userPaused = true;
      }, options);

      this.button.addEventListener('click', () => {
        if (this.video.paused) {
          this.userPaused = false;
          this.manualPlayback = true;
          play();
        } else {
          this.userPaused = true;
          this.manualPlayback = false;
          this.video.pause();
        }
      }, options);

      document.addEventListener('visibilitychange', syncPlayback, options);
      this.motionPreference.addEventListener('change', () => {
        if (this.motionPreference.matches) this.manualPlayback = false;
        syncPlayback();
      }, options);

      this.observer = new IntersectionObserver((entries) => {
        this.inView = entries[0].isIntersecting;
        syncPlayback();
      }, { threshold: 0.01 });
      this.observer.observe(this);
      reflectPlayback();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.observer?.disconnect();
      this.video?.pause();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
